import {
    IconButton,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    Button,
    InputAdornment
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    updateParentFieldList,
    isAddNewField,
    onChangeFieldName,
    isUseFieldInForm,
    isEditField,
    validateMinValueOfNumberField,
    validateMaxValueOfNumberField,
    isFieldError,
    getErrorByField,
    updateFieldListOnchangeData,
    getNumberFormStrings,
    updateFormMinNumber,
    updateFormMaxNumber,
    isPermissionDeleteField,
    validateAddFieldNameCustom,
    onChangeFieldNameREF,
    isDisplayOptionShareField
} from '../handler/CommonHandler';
import {
    getProjectNameOfField,
    isShowDuplicateButton,
    isSystemField,
    onCloseFieldExpandMore,
    removeCurrentGUIAddField,
    duplicateField,
    getOrgName
} from '@/component/formManagement/handler/FieldListHandler';
// import { duplicateField } from '../handler/FormListHandler';
import SettingFormDev from '../SettingFormDev';
import { duplicateField as duplicateFieldInForm } from '@/component/formManagement/handler/FormListHandler';
import ShareField from '../ShareField';
import FieldIdCommon from './FieldIdCommon';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

export default function AddFieldNumber(props) {
    // Atom
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);

    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);

    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);
    const currentFieldData = props.fieldAddList[indexAddField];
    // const [currentFieldData, setCurrentFielData] = useState(props.fieldAddList[indexAddField]);

    const [isUsingProject, setIsUsingProject] = useState(
        Utils.isEmpty(currentFieldData?.usingProjects)
            ? false
            : currentFieldData.usingProjects.includes(props.projectDetail.id)
    );
    const [isUsingForm, setIsUsingForm] = useState(
        Utils.isEmpty(currentFieldData?.isUsingForm) ? false : currentFieldData.isUsingForm
    );

    const [unitPosition, setUnitPosition] = useState(currentFieldData?.structure.unitPosition);

    const fieldRef = useRef('');

    const checkNameFieldEnter = () => {
        if (Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentFieldData.name).length > 0) {
            return true;
        } else {
            return false;
        }
    };

    const checkUnitFieldEnter = () => {
        if (currentFieldData.structure?.unit?.length > 0) {
            return true;
        } else {
            return false;
        }
    };

    const argsAll = {
        ...props,
        indexAddField,
        currentFieldData,
        isUsingProject,
        isUsingForm,
        requiredFields: true,
        checkUnitFieldEnter: checkUnitFieldEnter
    };

    /** handler enter text input name */
    const onEnterTextInputName = event => {
        let textValue = event.target.value;

        let isValidate = validateAddFieldNameCustom(textValue, argsAll);
        // if event diff enter then return
        if (isValidate && !Utils.isEmptyString(props.fieldAddList[indexAddField].structure.unit)) {
            if (props.isChangeData === false) props.setIsChangeData(true);
        }
        if (event.key !== 'Enter' || isValidate) {
            return;
        }

        let newName = {
            jp: {
                A: 'F',
                text: textValue
            }
        };

        // reset fieldType selected
        let fieldTypeSelectedList = [...props.fieldTypeSelectedList];
        fieldTypeSelectedList = Utils.removeItemInArrayById(
            props.currentAddField.id,
            fieldTypeSelectedList
        );
        props.setFieldTypeSelectedList(fieldTypeSelectedList);

        props.fieldAddList[indexAddField].name = newName;
        props.fieldAddList[indexAddField].usingProjects = isUsingProject
            ? [props.projectDetail.id]
            : [];
        props.fieldAddList[indexAddField].isUsingProject = isUsingProject;
        props.fieldAddList[indexAddField].isErrorValidate = false;
        props.fieldAddList[indexAddField].isShowInfo = false;

        // update in field list or dragdrop data
        updateParentFieldList(props, currentFieldData, newName, isUsingProject);
    };

    const onChangeUnit = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let unit = event.target.value;

        props.setFieldAddList(cloneFieldAddList);

        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
        const isNameFieldEnter = checkNameFieldEnter();
        if (isNameFieldEnter || unit) {
            if (props.isChangeData === false) props.setIsChangeData(true);
        } else {
            
            if (props.isChangeData === true) props.setIsChangeData(false);
        }
    };

    const onBlurUnit = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let unit = event.target.value;
        cloneFieldAddList[indexAddField].structure.unit = unit;

        props.setFieldAddList(cloneFieldAddList);
        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
        // update in field list or dragdrop data
        // let newName = cloneFieldAddList[indexAddField].name;
        // let structure = cloneFieldAddList[indexAddField].structure;
        // updateParentFieldList(props, currentFieldData, newName, isUsingProject, structure);
    };

    const onChangeUnitPosition = position => {
        let cloneFieldAddList = [...props.fieldAddList];
        cloneFieldAddList[indexAddField].structure.unitPosition = position;
        setUnitPosition(position);
        props.setFieldAddList(cloneFieldAddList);
        const isNameFieldEnter = checkNameFieldEnter();
        const isUnitFieldEnter = checkUnitFieldEnter();
        if (isNameFieldEnter && isUnitFieldEnter && props.isChangeData === false) props.setIsChangeData(true);
        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
    };

    const onChangeMinValue = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let indexInFieldList = Utils.findIndexInArrayById(
            currentFieldData.id,
            argsAll.fieldListInState
        );

        // let minValue = event.target.value ? Number(event.target.value) : null;
        let minValue = getNumberFormStrings('NEGATIVE_INTEGER', event.target.value);
        let maxValue = cloneFieldAddList[indexAddField].structure.maxValue;
        let minCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.minValue
                : null;
        let maxCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.maxValue
                : null;
        let hasValue = cloneFieldAddList[indexAddField].hasValue;

        let errors = cloneFieldAddList[indexAddField].errors
            ? cloneFieldAddList[indexAddField].errors
            : {};
        let validateMin = validateMinValueOfNumberField(minValue, maxValue, minCurrent, hasValue);
        errors.minValue = validateMin;

        //check maxValue
        let errorMaxValue = errors.maxValue;
        if (minValue <= maxValue && errorMaxValue && errorMaxValue.type === 'minLargerMaxError') {
            errors.maxValue = {};
        }

        cloneFieldAddList[indexAddField].errors = errors;
        cloneFieldAddList[indexAddField].structure.minValue = minValue;
        props.setFieldAddList(cloneFieldAddList);

        // validate input field
        // onValidateOnChangeMinMaxField('min', min, currentFieldData, argsAll);
        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
    };

    const onChangeMaxValue = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        let indexInFieldList = Utils.findIndexInArrayById(
            currentFieldData.id,
            argsAll.fieldListInState
        );

        // let maxValue = event.target.value ? Number(event.target.value) : null;
        let maxValue = getNumberFormStrings('NEGATIVE_INTEGER', event.target.value);
        let minValue = cloneFieldAddList[indexAddField].structure.minValue;
        let minCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.minValue
                : null;
        let maxCurrent =
            indexInFieldList !== -1
                ? argsAll.fieldListInState[indexInFieldList].structure.maxValue
                : null;
        let hasValue = cloneFieldAddList[indexAddField].hasValue;

        let errors = cloneFieldAddList[indexAddField].errors
            ? cloneFieldAddList[indexAddField].errors
            : {};
        let validateMax = validateMaxValueOfNumberField(maxValue, minValue, maxCurrent, hasValue);
        errors.maxValue = validateMax;

        //check minLength
        let errorMinValue = errors.minValue;
        if (minValue <= maxValue && errorMinValue && errorMinValue.type === 'minLargerMaxError') {
            errors.minValue = {};
        }

        cloneFieldAddList[indexAddField].errors = errors;
        cloneFieldAddList[indexAddField].structure.maxValue = maxValue;
        props.setFieldAddList(cloneFieldAddList);

        // validate input field
        // onValidateOnChangeMinMaxField('max', max, currentFieldData, argsAll);
        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
    };

    const onChangeIntegerOnly = () => {
        let cloneFieldAddList = [...props.fieldAddList];
        let integerOnly = !cloneFieldAddList[indexAddField].structure.integerOnly;
        cloneFieldAddList[indexAddField].structure.integerOnly = integerOnly;
        props.setFieldAddList(cloneFieldAddList);
        const isNameFieldEnter = checkNameFieldEnter();
        const isUnitFieldEnter = checkUnitFieldEnter();
        if (isNameFieldEnter && isUnitFieldEnter && props.isChangeData === false) props.setIsChangeData(true);
        updateFieldListOnchangeData(props, cloneFieldAddList[indexAddField]);
    };

    // update ref
    useEffect(() => {
        if (!Utils.isEmpty(currentFieldData) && !Utils.isEmpty(props.fieldRefList)) {
            props.fieldRefList[currentFieldData.id] = fieldRef;
        }
    });
    

    const handleOnChangeFieldName = (e, args) => {
        let currentFieldDataClone = { ...currentFieldData };
        currentFieldDataClone = onChangeFieldNameREF(e, currentFieldDataClone, args);
        // setCurrentFielData(currentFieldDataClone);
    }

    

    return (
        <>
            {indexAddField === -1 ? (
                <></>
            ) : (
                <li
                    className={
                        isUseFieldInForm(currentFieldData, props.formList, argsAll)
                            ? 'listField-li'
                            : 'listField-li background-color-usingForm'
                    }
                    id={currentFieldData.id}
                    // ref={props.fieldRefList[props.currentUpdateField.id]}
                    ref={fieldRef}
                    data-cy="add-number-field"
                    style={{ width: '100%' }}
                >
                    <div
                        className={
                            isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                ? 'fieldSetting-info fieldSetting-info--changeForm'
                                : 'fieldSetting-info fieldSetting-info--changeForm background-color-usingForm'
                        }
                    >
                        <div className="fieldSetting-thumb">
                            <img
                                src="/assets/image/icon-field03.svg"
                                alt=""
                                data-cy="add-number-field-icon"
                            />
                        </div>
                        <div className="fieldSetting-cmt">
                            <div className="fieldSetting-name">
                                <div className="formCreate">
                                    <TextField
                                        className="form-input-outlined"
                                        placeholder="フィールド名"
                                        onKeyPress={onEnterTextInputName}
                                        onChange={e => onChangeFieldName(e, argsAll)}
                                        // onChange={e => handleOnChangeFieldName(e, argsAll)}
                                        defaultValue={Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            currentFieldData.name
                                        )}
                                        disabled={!isEditField(currentFieldData, argsAll)}
                                        error={isFieldError('name', currentFieldData)}
                                        helperText={getErrorByField('name', currentFieldData)}
                                        onBlur={e => onChangeFieldName(e, argsAll)}
                                    // onBlur={e => onBlurUpdateField(currentFieldData, argsAll)}
                                    />
                                    <p className="fieldSetting-text">
                                        {getProjectNameOfField(currentFieldData, props.projectList)}
                                    </p>
                                    {currentFieldData?.affiliationOrganization !== props.corporationDetail.id && (
                                        <p className="fieldSetting-text  --3">
                                            {getOrgName(props?.allListCorp, currentFieldData?.affiliationOrganization)}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="fieldSetting-autofill">
                                <div
                                    className={
                                        isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                            ? 'fieldSetting-item'
                                            : 'fieldSetting-item background-color-usingForm'
                                    }
                                >
                                    {!isSystemField(currentFieldData) &&
                                        !isAddNewField(currentFieldData) && (
                                            <>
                                                {isShowDuplicateButton(currentFieldData) && (
                                                    <IconButton
                                                        className="itemTools"
                                                        onClick={e => {
                                                            setMoreActionPopover(null);
                                                            if (
                                                                props.parentPanelScreen ===
                                                                Constant.FORM_MANAGEMENT_SCREEN
                                                                    .LIST_FIELD
                                                            ) {
                                                                duplicateField(
                                                                    props,
                                                                    currentFieldData
                                                                );
                                                            } else if (
                                                                [
                                                                    'listFieldAddToForm',
                                                                    'listFieldInProject'
                                                                ].includes(props.regionDropIdBlock)
                                                            ) {
                                                                duplicateFieldInForm(
                                                                    props,
                                                                    currentFieldData,
                                                                    props.regionDropIdBlock
                                                                );
                                                            }
                                                            if (props.isChangeData === false) props.setIsChangeData(true);
                                                        }}
                                                    >
                                                        <img
                                                            src="/assets/image/icon-copy.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                )}

                                                {isPermissionDeleteField(
                                                    currentFieldData,
                                                    props.formList,
                                                    argsAll
                                                ) && (
                                                        <IconButton className="itemTools">
                                                            <img
                                                                src="/assets/image/icon-tabs-delete.svg"
                                                                alt=""
                                                                onClick={e => {
                                                                    props.handleClick(e);
                                                                    props.setCurrentFieldSelected(
                                                                        props.currentAddField
                                                                    );
                                                                    props.setIsOpenConfirmDeleteModal(
                                                                        true
                                                                    );
                                                                    props.handleClose();
                                                                }}
                                                            />
                                                        </IconButton>
                                                    )}

                                                {!props.disableBtnShowMore && (
                                                    <IconButton
                                                        className="itemTools itemTools-arrow"
                                                        onClick={e =>
                                                            onCloseFieldExpandMore(
                                                                props,
                                                                currentFieldData
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-accordion-gray.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                )}
                                            </>
                                        )}

                                    {/* add new field */}
                                    {!isSystemField(currentFieldData) &&
                                        isAddNewField(currentFieldData) && (
                                            <>
                                                <IconButton
                                                    className="itemTools"
                                                    onClick={event => {
                                                        setMoreActionPopover(null);
                                                        removeCurrentGUIAddField(props);
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/image/icon-tabs-delete.svg"
                                                        alt=""
                                                    />
                                                </IconButton>

                                                {!props.disableBtnShowMore && (
                                                    <IconButton
                                                        className="itemTools itemTools-arrow"
                                                        onClick={e =>
                                                            onCloseFieldExpandMore(
                                                                props,
                                                                currentFieldData
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-accordion-gray.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                )}
                                            </>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="fieldSetting-content">
                        <FieldIdCommon fieldId={props.currentAddField?.id}/>
                        <div className="lstCreateForm">
                            <span className="lstCreateForm-text">単位</span>
                            <div className="lstCreateForm-control">
                                <TextField
                                    className="form-control-wrapInput form-control-hg32"
                                    variant="outlined"
                                    onChange={onChangeUnit}
                                    defaultValue={currentFieldData.structure.unit}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                    error={isFieldError('unit', currentFieldData)}
                                    helperText={getErrorByField('unit', currentFieldData)}
                                    onBlur={onBlurUnit}
                                    data-cy="add-number-field-unit"
                                />
                            </div>
                        </div>

                        {/* checkbox */}
                        <div
                            className="lstCreateForm lstCreateForm--changePt"
                            data-cy="add-number-field-unit-position"
                        >
                            <p className="lstCreateForm-text lstCreateForm-text-selectbox">単位の位置</p>
                            <div className="lstCreateForm-control lstCreateForm-selectbox">
                                <RadioGroup
                                    className="multiple-radioLst"
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="後"
                                    name="radio-buttons-group"
                                >
                                    <FormControlLabel
                                        className="custom-radio"
                                        value="前"
                                        control={<Radio />}
                                        label="前"
                                        checked={
                                            unitPosition ===
                                            Constant.NUMBER_FIELD_DEFAULT.UNIT_POSITION_BEFORE
                                        }
                                        onChange={() =>
                                            onChangeUnitPosition(
                                                Constant.NUMBER_FIELD_DEFAULT.UNIT_POSITION_BEFORE
                                            )
                                        }
                                        name="radio-buttons"
                                        inputProps={{
                                            'aria-label': 'A',
                                            'data-cy': 'unit-postion-radio-before'
                                        }}
                                        disabled={!isEditField(currentFieldData, argsAll)}
                                    />
                                    <FormControlLabel
                                        className="custom-radio"
                                        value="後"
                                        control={<Radio />}
                                        label="後"
                                        checked={
                                            unitPosition ===
                                            Constant.NUMBER_FIELD_DEFAULT.UNIT_POSITION_AFTER
                                        }
                                        onChange={() =>
                                            onChangeUnitPosition(
                                                Constant.NUMBER_FIELD_DEFAULT.UNIT_POSITION_AFTER
                                            )
                                        }
                                        name="radio-buttons"
                                        inputProps={{
                                            'aria-label': 'A',
                                            'data-cy': 'unit-postion-radio-after'
                                        }}
                                        disabled={!isEditField(currentFieldData, argsAll)}
                                    />
                                </RadioGroup>
                            </div>
                        </div>

                        <div className="lstInput">
                            <p className="lstInput-text">数値範囲</p>
                            <div className="lstInput-control">
                                <div className="lstInput-number">
                                    <div className="lstInput-col">
                                        <div className="formNumber">
                                            <TextField
                                                className="form-control-wrapInput form-control-hg32"
                                                variant="outlined"
                                                type="number"
                                                data-cy="add-number-field-min-value"
                                                defaultValue={currentFieldData.structure.minValue}
                                                value={currentFieldData.structure.minValue}
                                                onChange={e => onChangeMinValue(e)}
                                                disabled={!isEditField(currentFieldData, argsAll)}
                                                error={isFieldError('minValue', currentFieldData)}
                                                helperText={getErrorByField(
                                                    'minValue',
                                                    currentFieldData
                                                )}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment>
                                                            <div className="formButton">
                                                                <Button
                                                                    className="btnNumber up"
                                                                    onClick={() => {
                                                                        updateFormMinNumber(
                                                                            props,
                                                                            currentFieldData.name,
                                                                            parseInt(currentFieldData
                                                                                .structure
                                                                                .minValue + 1),
                                                                            indexAddField,
                                                                            'value'
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        !isEditField(
                                                                            currentFieldData,
                                                                            argsAll
                                                                        )
                                                                    }
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                                <Button
                                                                    className="btnNumber down"
                                                                    onClick={() => {
                                                                        updateFormMinNumber(
                                                                            props,
                                                                            currentFieldData.name,
                                                                            parseInt(currentFieldData
                                                                                .structure
                                                                                .minValue - 1),
                                                                            indexAddField,
                                                                            'value'
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        !isEditField(
                                                                            currentFieldData,
                                                                            argsAll
                                                                        )
                                                                    }
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                            </div>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <span className="lstInput-item">~</span>
                                    <div className="lstInput-col">
                                        <div className="formNumber">
                                            <TextField
                                                className="form-control-wrapInput form-control-hg32"
                                                variant="outlined"
                                                type="number"
                                                data-cy="add-number-field-max-value"
                                                defaultValue={currentFieldData.structure.maxValue}
                                                value={currentFieldData.structure.maxValue}
                                                onChange={e => onChangeMaxValue(e)}
                                                disabled={!isEditField(currentFieldData, argsAll)}
                                                error={isFieldError('maxValue', currentFieldData)}
                                                helperText={getErrorByField(
                                                    'maxValue',
                                                    currentFieldData
                                                )}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment>
                                                            <div className="formButton">
                                                                <Button
                                                                    className="btnNumber up"
                                                                    onClick={() => {
                                                                        updateFormMaxNumber(
                                                                            props,
                                                                            currentFieldData.name,
                                                                            parseInt(currentFieldData
                                                                                .structure
                                                                                .maxValue + 1),
                                                                            indexAddField,
                                                                            'value'
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        !isEditField(
                                                                            currentFieldData,
                                                                            argsAll
                                                                        )
                                                                    }
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                                <Button
                                                                    className="btnNumber down"
                                                                    onClick={() => {
                                                                        updateFormMaxNumber(
                                                                            props,
                                                                            currentFieldData.name,
                                                                            parseInt(currentFieldData
                                                                                .structure
                                                                                .maxValue - 1),
                                                                            indexAddField,
                                                                            'value'
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        !isEditField(
                                                                            currentFieldData,
                                                                            argsAll
                                                                        )
                                                                    }
                                                                >
                                                                    <img
                                                                        src="/assets/image/icon-arrow-nav.svg"
                                                                        alt=""
                                                                    />
                                                                </Button>
                                                            </div>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="lstCreateForm lstCreateForm--changePt">
                            <p className="lstCreateForm-text">整数のみ</p>
                            <div className="lstCreateForm-control">
                                <div className="switch-check">
                                    <input
                                        data-cy="add-number-field-integer-only"
                                        type="checkbox"
                                        id={`${props.currentAddField.id}_integerOnly`}
                                        defaultChecked={currentFieldData.structure.integerOnly}
                                        onChange={onChangeIntegerOnly}
                                        disabled={!isEditField(currentFieldData, argsAll)}
                                    />
                                    <label
                                        htmlFor={`${props.currentAddField.id}_integerOnly`}
                                    ></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Share option */}
                    {isDisplayOptionShareField(props?.parentPanelScreen, projectInuseDetail?.id, currentFieldData.affiliationProject, corporationDetail?.rootFlag) && <ShareField {...props} />}

                    {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                        props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                            <SettingFormDev {...props} />
                        )}
                </li>
            )}
        </>
    );
}
